import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Configuration from "../configuration";
var token = localStorage.getItem("x-access-token");


export const getListReclamation = createAsyncThunk("reclamation/listReclamation", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/listReclamation", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action),
  });
  const reclamation = await response.json();
  return reclamation;
});

//upload  file
export const saveFile = createAsyncThunk("reclamation/saveFile", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/saveFile", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const reclamation = await response.json();
  return reclamation;
});

//upload  file
export const saveFileAvoir = createAsyncThunk("reclamation/saveFileAvoir", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/saveFileAvoir", {
    method: 'POST',
    headers: {
      'Accept': 'application/*',
      'x-access-token': token,
    },
    body: action
  });
  const reclamation = await response.json();
  return reclamation;
});



export const getReclamationById = createAsyncThunk("reclamation/getReclamationById", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/getReclamationById/" + id, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const reclamation = await response.json();
  return reclamation;
});


export const getCommentaireReclamation = createAsyncThunk("reclamation/getCommentaireReclamation", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/getCommentaireReclamation/" + action.idReclamation, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const reclamation = await response.json();
  return reclamation;
});

export const updateReclamation = createAsyncThunk("reclamation/updateReclamation", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/updateReclamation", {
    method: "Post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});

export const updateReclamationAll = createAsyncThunk("reclamation/updateReclamationAll", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/updateReclamationAll", {
    method: "Post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});


//getDetailReclamation
export const getDetailReclamation = createAsyncThunk("reclamation/getDetailReclamation", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/getDetailReclamation/" + id, {
    method: "get",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const reclamation = await response.json();
  return reclamation;
});



export const getLotArticle = createAsyncThunk("reclamation/getLotArticle", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/getLotArticle/"+action.CodeProduit, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const reclamation = await response.json();
  return reclamation;
});

export const getBlLot = createAsyncThunk("reclamation/getBlLot", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/getBlLot/"+action.lot, {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
  });
  const reclamation = await response.json();
  return reclamation;
});




export const saveReclamation = createAsyncThunk("reclamation/saveReclamation", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/saveReclamation", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});
export const reclamationAdded = createAsyncThunk("reclamation/addReclamation", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/addReclamation", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});

export const envoyerReclamationToAfc = createAsyncThunk("reclamation/envoyerReclamationToAfc", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/envoyerReclamationToAfc", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});


export const changeEtatEntete = createAsyncThunk("reclamation/changeEtatEntete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/changeEtatEntete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});


export const changeStatusEntete = createAsyncThunk("reclamation/changeStatusEntete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/changeStatusEntete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});


export const getDetailEntete = createAsyncThunk("reclamation/getDetailEntete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/getDetailEntete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});


export const getDetailRetour = createAsyncThunk("reclamation/getDetailRetour", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/getDetailRetour", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});

export const getDetailLigneEntete = createAsyncThunk("reclamation/getDetailLigneEntete", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/getDetailLigneEntete", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});

export const getListEnteteReclamation = createAsyncThunk("reclamation/getListEnteteReclamation", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/getListEnteteReclamation", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});

export const fetchAllReclamation = createAsyncThunk("reclamation/fetchAllReclamation", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/fetchAllReclamation", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});

export const ChangeEtatReclamation = createAsyncThunk("reclamation/ChangeEtatReclamation", async (action) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/ChangeEtatReclamation", {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'x-access-token': token
    },
    body: JSON.stringify(action)
  });
  const reclamation = await response.json();
  return reclamation;
});

export const deleteReclamation = createAsyncThunk("reclamation/delete", async (id) => {
  const response = await fetch(Configuration.BACK_BASEURL + "reclamation/delete/" + id, {
    method: "delete",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    },
  });
  const reclamation = await response.json();
  return reclamation;
});
const reclamationReduce = createSlice({
  name: "reclamation",
  initialState: {
    entities: [],
    loading: false,
  },
  reducers: {




  },
  extraReducers: {

  },
});

export const { } = reclamationReduce.actions;

export default reclamationReduce.reducer;
